module.exports = __webpack_public_path__ + "static/media/vf_wcoat_core.86442f00.svg";